<style>
    .ly-total-amount {
        border:1px solid #dfe6ec;
        border-top: 0;
        text-align: right;
        color: #48576a;
        font-size: 12px;
        padding: 8px 50px;
    }
</style>
<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新建现金回款单</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard"> 
            <ly-product-table 
                ref="productTable"
                :thead-config="productConfig"
                v-model="submitForm.customer">
                <div class="ly-total-amount">
                    回款金额小计: {{totalAmount}}
                </div>
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
    </div>
</template>
<script>
    /**
     * 客户回款，银行登记单 新增
     * @time 2017-10-25
     * @author zjs
     */
    import AddFormConfig from './add-form'
    import AddProductConfig from './add-product'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import LyRouterButton from '@c/router-button'

    import {mapGetters} from 'vuex'
    export default {
        mixins: [
            AddFormConfig, 
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyProductTable,
            LyRouterButton
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ]),

            // 总的贴损金额，顺便将总的理赔金额 在这计算了
            totalAmount () {
                let total = 0 
                this.submitForm.customer.forEach(function (el) {
                    // 计算总的贴损金额
                    if (el.huikuan_amount && !isNaN(el.huikuan_amount)) {
                        total = (parseFloat(total) + parseFloat(el.huikuan_amount)).toFixed(2)
                    }
                }, this)
                return total
            }
        },
        data () {
            return {
                num1: "",
                submitLoad: false, // 提交按钮的状态标识
                submitForm: {
                    uuid: '',
                    tag_type: 'cash',
                    huikuan_xiaoji: 0, // 回款金额小计
                    customer: []
                } // 提交的表单数据
            }
        },
        mounted () {
            // 设置UUID
            this.submitForm.uuid = this.$utils.createUUID()
            // 初始设置制作单人
            this.initData()
        },
        watch: {
            userInfo () {
                this.initData()
            },
            '$route' (to, from) {
                // 清空之前的输入
                if (to.name === 'PaymentBashbackAdd') {
                    this.$refs['searchForm'].resetForm()
                    this.$refs['productTable'].resetList()
                    // 初始化数据
                    this.initData()
                }
            }
        },
        methods: {
            /**
             * 初始化的数据设置
             */
            initData () {
                // 初始设置制作单人id
                this.$refs['searchForm'].initBindFormData({
                    zhidanren_id: this.userInfo.id
                })
            },
            submit () {
                let productList = this.$refs['productTable'].getProductData()
                if (this.$refs['searchForm'].validateForm()) {
                    if (productList && productList.length > 0) {
                        // 货品验证
                        let productMsg = this.validateProduct(productList)
                        // 货品验证不通过的情况
                        if (productMsg.length > 0) {
                            this.$alert(productMsg, '客户信息录入提示', {
                                confirmButtonText: '确定'
                            })
                        } else {
                            // 获得得查询的字段
                            this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                            // 判断收款金额是否一致
                            if (parseFloat(this.submitForm.amount) === parseFloat(this.totalAmount)) {
                                // 表单中写入货品列表
                                this.submitForm['customer'] = productList
                                console.log('submitForm:%O', this.submitForm)
                                // this.$confirm('提交后本单据即为待审核状态，需出纳进行对账确认。确认要提交?', '提示', {
                                //     confirmButtonText: '确定',
                                //     cancelButtonText: '取消',
                                //     type: 'warning'
                                // }).then(() => {
                                    this.doCreate()
                                // })
                            } else {
                                this.$message({
                                    message: '收支金额与回款金额数据不一致，请修改！',
                                    type: 'warning'
                                })
                            }
                        }
                    } else {
                        this.$message({
                            message: '请添加客户信息',
                            type: 'warning'
                        })
                    }
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            },
            /**
             * 执行书记的提交
             * @return {[type]} [description]
             */
            doCreate () {
                this.submitLoad = true
                this.submitForm.huikuan_xiaoji = this.totalAmount
                // 提交数据
                this.$api.create('api/fluent',this.submitForm).then((rs) => {
                    this.$alert('数据提交成功', '新增', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.submitLoad = false
                            // 跳转到详情页面
                            this.$router.push('/bill/payconfirm/info/' + rs.id)
                        }
                    });
                    // 更新UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                }).catch((error) => {
                    this.submitLoad = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            }
        }
    }
</script>